<template>
    <div class="import-rule-box">
        <v-page-header
            :back="{
                title: '组织架构',
                goBack: goback,
            }"
            title="从企业微信导入员工"
        >
            <import-result slot="caption" />
            <lamp-tip local-key="mng-import-work-weixin-tip">
                <ul>
                    <li>-导入后企点中将自动新建企点账号，两个账号默认为绑定关系</li>
                    <li>
                        -如果需要将企业微信和已有的企点账号进行绑定，请确保企业微信账号名和企点账号名相同，导入后两个账号将自动关联
                    </li>
                    <li>-管理员在组织架构中为员工修改初始密码后，员工才能登录企点</li>
                    <li>-如果未搜索到员工请检查应用可见范围，并点击<a class="sync-btn" @click="sync">立即同步</a></li>
                </ul>
            </lamp-tip>
        </v-page-header>
        <v-form kind="desc">
            <v-form-item label="导入的员工" class="import-role-rule" name="staffDepList">
                <div class="import-role-rule-content">
                    <div
                        v-if="staffDepList.length > 0"
                        class="import-role-rule-event import-role-rule-display"
                    >
                        <role-org-item
                            v-model="staffDepList"
                            disabled
                        />
                    </div>
                    <div class="import-role-rule-event import-role-rule-display">
                        <org-select
                            :use-big-tree="true"
                            :check-strictly="true"
                            :single="false"
                            :with-checkbox="false"
                            :selected="staffDepList"
                            :cust-fetch-tree="getDepTreeNode"
                            :cust-fetch-search="custFetchSearch"
                            mode="dialog"
                            title="选择员工"
                            @confirm="onOrgSelectConfirm"
                        >
                        <v-button
                            slot="trigger"
                            type="link"
                            kind="primary"
                        >
                            <v-icon name="basic_new_line" remote />添加
                        </v-button>
                        </org-select>
                    </div>
                    <!-- <div class="import-role-rule-next">
                        <span class="import-role-rule-txt">当导入的员工已在企点组织架构中时：</span>
                        <v-select
                            v-model="updateInfo"
                            class="import-role-rule-select"
                            :options="updateSelect"
                            :inline="true"
                            :no-clear="true"
                        ></v-select>
                    </div> -->
                </div>
            </v-form-item>
            <v-form-item class="import-role-rule" label="权限角色" name="role" desc="如员工需要在企业微信上使用企点相关能力，请选择相关套餐的权限角色">
                <div class="import-role-rule-content">
                    <div
                        v-if="allRoleRules.length > 0"
                        class="import-role-rule-event"
                    >
                        <role-item
                            v-model="allRoleRules"
                            disabled
                            @handleChange="showRoleSelectPanel"
                        />
                    </div>
                </div>
                <div class="import-role-rule-event">
                    <role-select-panel
                        v-model="showRolePanel"
                        :title="title"
                        :tips="tips"
                        :selected-id-arr="selectedIdArr"
                        :extra-req-params="extraReqParams"
                        :set-package-disable="false"
                        @confirm="onRoleSelectConfirm"
                    />
                </div>
                <v-button
                    type="link"
                    kind="primary"
                    @click="showRoleSelectPanel()"
                >
                    <v-icon name="basic_new_line" remote />添加
                </v-button>
            </v-form-item>
            <!-- <div class="import-role-rule">
                <div class="import-role-rule-label">短信通知</div>
                <div class="import-role-rule-content">
                    <v-checkbox v-model="sendMsgByTel" label="将企点账号和初始密码通过短信发送给员工" />
                    <div class="import-role-rule-next import-role-rule-top">
                        <span class="import-role-rule-txt">
                            如果员工在企业微信上未绑定手机号，则不发送短信<br />
                            如果不发送短信，需要管理员在组织架构中为员工修改初始密码后，员工才能登录企点
                        </span>
                    </div>
                </div>
            </div> -->

            <v-footer-actionbar
                class="import-role-botton"
                :layout="actionConfig"
                size="large"
                @confirm="toImport"
                @cancel="replaceRoute('/mng/org')"
            />
        </v-form>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import OrgSelect from '@/components/org-select';
import RoleSelectPanel from '@/components/role-select-panel';
import roleOrgItem from '@/components/role-org-item/index';
import roleItem from '@/components/role-item/index';
import getDepTreeNode from '@/cgi/getDepTreeNode';

import ImportResult from '../../import-result';
import LampTip from '@/components/lamp-tip/index.vue';
import { debounce } from '@tencent/qd-lib';

export default {
    components: {
        OrgSelect,
        RoleSelectPanel,
        roleOrgItem,
        roleItem,
        ImportResult,
        LampTip,
    },
    data() {
        return {
            // sendMsgByTel: true,
            sendMsgByTel: false, // 由于短信通知取消，所以这个传参值改为false
            // updateInfo: 2,
            // updateSelect: [
            //     {
            //         text: '更新他们的资料',
            //         value: 2
            //     },
            //     {
            //         text: '不更新他们的资料',
            //         value: 1
            //     }
            // ],
            showRolePanel: false,
            // 弹框标题
            title: '选择角色',
            tips: '从企业微信同步员工后，将消耗角色所对应的套餐配额',
            // 请求获取角色列表接口额外添加的参数，创建员工时传opt为create，编辑员工时传入员工的kfext值
            extraReqParams: {
                opt: 'fromWework',
                // kfext: 2355052451
            },

            importIng: false,
            staffDepList: [],
            allRoleRules: [],
            getDepTreeNode,
        };
    },

    computed: {
        orgSelectText() {
            if (this.staffDepList.length > 0) {
                return '修改';
            }

            return '选择';
        },

        selectedIdArr() {
            return this.allRoleRules.map(item => item.role_id);
        },
        actionConfig() {
            return {
                primary: {
                    text: '导入',
                    kind: 'primary',
                    loading: this.importIng,
                },
                cancel: {
                    text: '取消',
                    kind: 'default',
                },
            };
        },
    },

    methods: {
        sync: debounce(function () {
            this.$ajax.gatewayPost('/v1/basic/corp/wework/triggerOrgSync').then((res) => {
                if (res && res.code === 0) {
                    this.$message.success('企微最新组织架构数据拉取中，请耐心等待…');
                }
            });
        }, 1000),
        goback() {
            window.location.href = '/mng/org';
        },
        onOrgSelectConfirm(data) {
            data.forEach((item) => {
                item.iconArr = [];
                if (item.isFolder || item.isParent) {
                    item.iconArr.push('basic_file_line');
                } else {
                    item.iconArr.push('basic_me_line');
                }

                if (item.hasSelected) {
                    item.iconArr.push('selected');
                }

                item.iconArr = item.iconArr.join('-');
            });
            this.staffDepList = [...data];
        },

        onRoleSelectConfirm(checkedItemArr) {
            const formatCheckedArr = checkedItemArr.map(item => ({
                role_id: item.roleId,
                role_name: item.roleName,
            }));
            this.allRoleRules = formatCheckedArr;
        },

        showRoleSelectPanel() {
            this.showRolePanel = true;
        },

        // 根路径跳转
        replaceRoute(path) {
            window.location.replace(path);
        },

        custFetchTree(params) {
            const { isFirstFetch, id } = params;

            return Gateway.get('/v1/wework/DepTreeNode', {
                depId: isFirstFetch ? 0 : id,
            }).then(data => ({
                list: this.transTreeData(data),
            }));
        },

        custFetchSearch(params) {
            const { keywords, index, count } = params || {};

            return Gateway.get('/v1/wework/SearchUser', {
                keyword: keywords,
                page: index + 1,
                size: count,
            }).then(data => ({
                list: this.transTreeData(data),
            }));
        },

        transTreeData(data) {
            const { deps, users } = data || {};
            const list = [];

            if (users && users.length) {
                users.forEach((uItem) => {
                    const transItem = { ...uItem };

                    transItem.id = uItem.userid;
                    transItem.isParent = 0;
                    list.push(transItem);
                });
            }

            if (deps && deps.length) {
                deps.forEach((dItem) => {
                    const transItem = { ...dItem };

                    transItem.isParent = 1;
                    list.push(transItem);
                });
            }

            return list;
        },

        // 导入
        toImport() {
            if (this.staffDepList.length === 0) {
                this.$message.error('导入员工不能为空');
                return;
            }
            if (this.allRoleRules.length === 0) {
                this.$message.error('权限角色不能为空');
                return;
            }
            this.importReq();
        },

        importReq() {
            const depts = [];
            const staffs = [];

            this.staffDepList.forEach((item) => {
                const { id, isFolder } = item || {};
                if (isFolder) {
                    depts.push(id);
                } else {
                    staffs.push(id);
                }
            });

            this.importIng = true;

            Gateway.post('/v1/wework/ManualImport', {
                depts,
                staffs,
                update_info: this.updateInfo,
                // send_msg_by_tel: this.sendMsgByTel ? 2 : 1,
                send_msg_by_tel: 1,
                default_roles: this.allRoleRules,
            })
                .then((data) => {
                    const { id } = data || {};
                    this.$emit('importSuccess', id);
                    this.importIng = false;
                })
                .catch((message) => {
                    this.$message.error(message || '导入失败');
                    this.importIng = false;
                });
        },
    },
};
</script>
<style scoped lang="less">
@import './import-with-rule.less';
</style>
